module.exports = __webpack_public_path__ + "media/images/footer-btn-top-0654fb7edbae3c699959bf872e2a563d.png";